import API, { setAxiosToken } from "core/networks/API";
import { call, put, takeLatest } from "redux-saga/effects";
import { API_FETCH_ME_CLIENT, API_LOGIN, API_LOGIN_SNS, API_LOGOUT_CLIENT } from "../api";
import {
  fetchMeError,
  fetchMeSucess,
  loginFailed,
  loginSuccess,
  logOutFaild,
  logOutSuccess,
} from "./actions";
import { FETCH_ME_DATA, LOGIN_REQUEST, LOGOUT_REQUEST, } from "./types";
import { AxiosResponse } from "axios";
import { deviceStorage } from "core/utils/devicestorage";
import { config } from "core/config/app";

function* logIn(_action: any): any {
  try {
    const response = yield call(() => {
      let url = API_LOGIN;
      url = _action.payload?.type ? API_LOGIN_SNS : API_LOGIN
      
      return API.post(url, _action.payload);
    });
    const { data } = response;
    //console.log(data?.code === 200,'data logIn', data);
    if (data?.code === 200) {
      
      deviceStorage[localStorage.getItem("storage_driver") || "session"].setItem(config.appPackage + '_X_TOKEN', data?.data?.token)
      setAxiosToken(data?.data?.token)

      yield put(loginSuccess(data));
    }else{
      yield put(loginFailed(data));
    }
  } catch (error: any) {
    const errors = error.response?.data || {}
		yield put(loginFailed(errors));
  }
}
function* fetchMe() {
  try {
    const res: AxiosResponse = yield call(API.get, API_FETCH_ME_CLIENT, {});
    yield put(fetchMeSucess(res.data.data));
  } catch (error) {
    console.log(error, "error fetchMe");
    
    yield put(fetchMeError());
  }
}

function* logOut() {
  try {
    // removeAllStorage();
    const data = {};
    const response: AxiosResponse = yield call(API.post, API_LOGOUT_CLIENT, data);
    if (response.status == 200) {
      yield put(logOutSuccess(response));
    } else {
      yield put(logOutFaild(response));
    }
  } catch (error) {
    console.log(error, "error logOut");
    
  }
}



export default function* AuthSaga() {
  yield takeLatest(LOGIN_REQUEST, logIn);
  yield takeLatest(FETCH_ME_DATA, fetchMe);
  yield takeLatest(LOGOUT_REQUEST, logOut);
}
